import { Button, Grid, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import ProgressPlan from "views/JobDetailPage/Report/components/ProgressPlan";
import ResultWorking from "./ResultWorking";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import "./WrapperReport.scss";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import NumberReport from "./NumberReport";
import ChartGroup from "./ChartGroup";
import ChartTask from "./ChartTask";
import ChartMember from "./ChartMember";
import ReportCreation from "./ReportCreation/ReportCreation";
import { apiService } from "constants/axiosInstance";
import { Box, Popover } from "@mui/material";
import ReportItem from "./ReportItem";
import AlertModal from "components/AlertModal";
import PopoverMore from "./PopoverMore";
import { connect, useDispatch, useSelector } from "react-redux";
import { actionToast } from "actions/system/system";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import { v4 as uuidv4 } from "uuid";
import {
  getReportCategories,
  getReportCategoriesSuccess,
  updateModalReport,
} from "../controllers/actions";
import {
  selectReportCategories,
  selectModalReport,
} from "../controllers/selectors";
import InfiniteScroll from "react-infinite-scroller";
import {
  CustomEventEmitter,
  CustomEventEmitterWithParams,
} from "constants/events";
import { viewPermissionsSelector } from "views/ProjectPage/selectors";
import { useParams } from "react-router-dom";

export const useStyles = makeStyles({
  btnEditReport: {
    minWidth: 30,
    maxWidth: 40,
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    margin: "0px 3px",
    "&:hover": {
      backgroundColor: "#0000000a",
    },
  },
  iconColor: {
    color: "#505050",
  },
  iconButton: {
    marginRight: "4px",
  },
  textExplain: {
    color: "#666",
    marginLeft: "8px",
    marginTop: "8px",
    marginBottom: "30px",
  },
  containerCustomReport: {
    marginTop: 0,
  },
});

const ReportProject = ({
  report,
  project,
  reportExtend,
  isDefault = true,
  defaultCollpase = true,
  handleDeleteCategory,
  handleEditCategory,
  viewPermissions,
}) => {
  const { projectId } = useParams();
  const classes = useStyles();
  const [alert, setAlert] = React.useState(false);
  const [alertReportItem, setAlertReportItem] = React.useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selectedCategory, setSelectedCategory] = React.useState(undefined);
  const [collapseReport, setCollapseReport] = React.useState(defaultCollpase);
  const { openCreateReport, selectedReport, edit } = useSelector(
    selectModalReport()
  );
  // const [openCreateReport, setOpenCreateReport] = React.useState(false);
  // const [selectedReport, setSelectedReport] = React.useState(undefined);
  // const [edit, setEdit] = React.useState(false);
  const reportCategories = useSelector(selectReportCategories());
  console.log(report, "report page");
  const handleToast = async (type, message) => {
    dispatch(actionToast(type, message));
    setTimeout(() => dispatch(actionToast(null, "")), 2000);
  };

  console.log(openCreateReport, "openCreateReport modal");
  const isWebview = document.location.pathname.search("webview") !== -1;
  const canUpdate =
    viewPermissions?.permissions?.[projectId]?.update_project ?? false;

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Grid item xs={9} md={9} lg={10} xl={11}>
          <Grid
            container
            direction="row"
            onClick={() => {
              setCollapseReport(!collapseReport);
            }}
          >
            <Grid item direction="row">
              <Typography
                variant="h6"
                component="div"
                style={{
                  textTransform: "uppercase",
                  cursor: "pointer",
                }}
              >
                {isDefault && t("views.report_page.TITLE_REPORT_DEFAULT")}
                {!isDefault && reportExtend.name}
              </Typography>
            </Grid>
            <Grid item>
              {collapseReport && (
                <ArrowRightIcon className={classes.iconColor} />
              )}
              {!collapseReport && (
                <ArrowDropDownIcon className={classes.iconColor} />
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={3} md={3} lg={2} xl={1} sx={{ textAlign: "right" }}>
          <Grid container direction="row">
            {!isDefault && canUpdate && !isWebview && (
              <Button variant="text" className={classes.btnEditReport}>
                <AddIcon
                  className={classes.iconColor}
                  onClick={() => {
                    dispatch(
                      updateModalReport({
                        edit: false,
                        openCreateReport: true,
                        selectedReport: {
                          category_id: reportExtend.id,
                        },
                      })
                    );
                  }}
                />
              </Button>
            )}
            {!isDefault && canUpdate && !isWebview && (
              <PopoverMore
                items={[
                  !isDefault && {
                    title: t("IDS_WP_EDIT"),
                    onClick: () => {
                      handleEditCategory(reportExtend);
                      // setEdit(true);
                      // setOpenCreateReport(true);
                      // setSelectedCategory({
                      //   ...reportExtend,
                      //   category_id: reportExtend.id,
                      // });
                    },
                  },
                  // { title: t("IDS_WP_HIDE") },
                  !isDefault && {
                    title: t("IDS_WP_DELETE"),
                    onClick: () => {
                      setAlert(true);
                      setSelectedCategory(reportExtend);
                    },
                    sx: { color: "red" },
                  },
                ]}
              >
                <Button variant="text" className={classes.btnEditReport}>
                  <MoreHorizIcon className={classes.iconColor} />
                </Button>
              </PopoverMore>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={2}>
        <Grid
          container
          onClick={() => {
            setCollapseReport(!collapseReport);
          }}
        >
          <Typography component="p" className={classes.textExplain}>
            {isDefault && t("views.report_page.DES_REPORT_DEFAULT")}
            {!isDefault && (reportExtend?.description ?? " ")}
          </Typography>
        </Grid>
        {/* Báo cáo mặc đinh */}
        {!collapseReport && isDefault && (
          <Grid
            container
            justifyContent="row"
            spacing={2}
            className={classes.containerCustomReport}
          >
            <Grid container spacing={2} style={{ padding: "0px 16px 0px" }}>
              <NumberReport
                title={t("PROJECT_PAGE.REPORT.WORK")}
                count={report?.total_task}
                backgroundColor="#00e396"
                isDefault={true}
              />

              <NumberReport
                isDefault={true}
                title={t("PROJECT_PAGE.REPORT.GROUP")}
                count={report?.total_group_task}
                backgroundColor="white"
              />
              <NumberReport
                isDefault={true}
                title={t("PROJECT_PAGE.REPORT.MEMBERS")}
                count={report?.total_members}
                backgroundColor="#92c4f2"
              />
              <NumberReport
                isDefault={true}
                title={t("PROJECT_PAGE.REPORT.DOCUMENTS")}
                count={report?.total_file}
                backgroundColor="#feb019"
              />
            </Grid>
            <ProgressPlan project={project} />
            <ResultWorking report={report} />
            {report?.statistic_group_task && (
              <ChartGroup statisticGroup={report?.statistic_group_task} />
            )}
            {report?.statistic_task_status && (
              <ChartTask statisticTask={report?.statistic_task_status} />
            )}
            {report?.statistic_members && (
              <ChartMember statisticMembers={report?.statistic_members} />
            )}
          </Grid>
        )}

        {!collapseReport &&
          !isDefault &&
          reportExtend?.reports?.filter((item) => !item.is_hidden).length ===
            0 && (
            <Typography component="p" className={classes.textExplain}>
              <i>{t("views.report_page.NO_REPORTS")}</i>
            </Typography>
          )}

        {/* Báo cáo tạo thủ công */}
        {!collapseReport &&
          !isDefault &&
          reportExtend?.reports
            ?.filter((item) => !item.is_hidden)
            .map((item) => (
              <ReportItem
                // key={uuidv4()}
                defaultData={item}
                categoryId={reportExtend.id}
                handleEdit={(dataReport) => {
                  dispatch(
                    updateModalReport({
                      edit: true,
                      openCreateReport: true,
                      selectedReport: {
                        ...dataReport,
                        category_id: reportExtend.id,
                      },
                    })
                  );
                }}
                handleDelete={(dataReport) => {
                  setAlertReportItem(true);
                  dispatch(
                    updateModalReport({
                      selectedReport: dataReport,
                    })
                  );
                }}
                handlePreview={(form) => {
                  //
                }}
              />
            ))}
      </Grid>
      {openCreateReport && selectedReport?.category_id === reportExtend?.id && (
        <ReportCreation
          open={openCreateReport}
          setOpen={(value) => {
            dispatch(
              updateModalReport({
                edit: false,
                openCreateReport: value,
              })
            );
          }}
          selectedReport={selectedReport}
          edit={edit}
          onFinish={({ name, description, category_id, newReport }) => {
            let arr = [];
            console.log(
              name,
              description,
              category_id,
              newReport,
              "new report new cate"
            );
            //
            if (category_id !== reportExtend?.id) {
              arr = reportCategories.map((item) => {
                //
                const clone = JSON.parse(JSON.stringify(item));
                if (item.id === category_id) {
                  clone.reports = (clone?.reports ?? []).concat({
                    ...(newReport ? newReport : selectedReport),
                    category_id,
                    name,
                    description,
                  });
                  //
                  return clone;
                }
                if (item.id === selectedReport.category_id) {
                  clone.reports = (clone?.reports ?? []).filter(
                    (e) => e.id !== selectedReport.id
                  );
                  //
                  return clone;
                }
                return item;
              });
            } else {
              arr = reportCategories.map((item) => {
                if (item.id === reportExtend.id) {
                  const clone = JSON.parse(JSON.stringify(item));
                  if (!edit) {
                    if (newReport) {
                      clone.reports = (clone?.reports ?? []).concat(newReport);
                    }
                  } else {
                    clone.reports = clone.reports?.map((e) => {
                      if (e.id === selectedReport.id) {
                        return {
                          ...e,
                          name,
                          description,
                        };
                      }
                      return e;
                    });
                  }

                  return clone;
                }
                return item;
              });
            }
            dispatch(
              updateModalReport({
                edit: false,
                openCreateReport: false,
              })
            );
            CustomEventEmitterWithParams("report-" + selectedReport.id, {
              detail: {
                name,
                description,
              },
            });
            dispatch(getReportCategoriesSuccess(arr));
            setCollapseReport(false);
          }}
        />
      )}

      <AlertModal
        open={alertReportItem}
        setOpen={setAlertReportItem}
        content={t("IDS_WP_ALERT_CONTENT")}
        onConfirm={async () => {
          try {
            const response = await apiService({
              url: "/project/report/delete-report",
              method: "POST",
              data: {
                report_id: selectedReport.id,
              },
            });
            if (response?.data?.state) {
              const arr = reportCategories.map((item) => {
                if (item.id === reportExtend.id) {
                  const clone = JSON.parse(JSON.stringify(item));
                  clone.reports = (clone?.reports ?? []).filter(
                    (item) => item.id !== selectedReport.id
                  );
                  return clone;
                }

                return item;
              });
              dispatch(getReportCategoriesSuccess(arr));
              handleToast("success", t("IDS_WP_DELETE_COMPLETE"));
            } else {
              SnackbarEmitter(
                SNACKBAR_VARIANT.ERROR,
                response?.data?.msg ?? DEFAULT_MESSAGE.MUTATE.ERROR
              );
            }
          } catch (err) {
            SnackbarEmitter(
              SNACKBAR_VARIANT.ERROR,
              DEFAULT_MESSAGE.MUTATE.ERROR
            );
          }
        }}
      />

      <AlertModal
        open={alert}
        setOpen={setAlert}
        content={t("IDS_WP_ALERT_CONTENT")}
        onConfirm={async () => {
          try {
            const response = await apiService({
              url: "/project/report/delete-category",
              method: "POST",
              data: {
                category_id: selectedCategory.id,
              },
            });
            if (response?.data?.state) {
              handleDeleteCategory(selectedCategory.id);
              handleToast("success", t("IDS_WP_DELETE_COMPLETE"));
            } else {
              SnackbarEmitter(
                SNACKBAR_VARIANT.ERROR,
                response?.data?.msg ?? DEFAULT_MESSAGE.MUTATE.ERROR
              );
            }
          } catch (err) {
            SnackbarEmitter(
              SNACKBAR_VARIANT.ERROR,
              DEFAULT_MESSAGE.MUTATE.ERROR
            );
          }
        }}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    viewPermissions: viewPermissionsSelector(state),
  };
};

export default connect(mapStateToProps, (state) => {})(ReportProject);
